import type { SidebarMenuItem } from '@nebula-layout/layout';
import { filterVaultAdminDashboardMenuItems } from './vault-admin-menu.util';
import { normalizeMenuLabelKey } from './vault-menu-labels';

function normalizedRoute(item: SidebarMenuItem): string {
  return (item.route ?? '').toLowerCase().split('?')[0].split('#')[0];
}

/** Respaldo Externo / cloud: oculto en sidebar (módulo no expuesto aún en UI). */
export function menuItemIsVaultCloudHidden(item: SidebarMenuItem): boolean {
  if (item.children?.length) {
    return item.children.every((child) => menuItemIsVaultCloudHidden(child));
  }

  const route = normalizedRoute(item);
  if (route.includes('/layout/vault/cloud') || /\/vault\/cloud\/?$/.test(route)) {
    return true;
  }

  const labelKey = normalizeMenuLabelKey(item.label ?? '').toLowerCase();
  if (labelKey === 'respaldo externo' || labelKey === 'options vault cloud') {
    return true;
  }

  const raw = (item.label ?? '').toLowerCase();
  return /respaldo\s*externo/.test(raw) || /options vault cloud/.test(raw);
}

function stripHiddenFromList(items: SidebarMenuItem[]): SidebarMenuItem[] {
  return items
    .filter((item) => !menuItemIsVaultCloudHidden(item))
    .map((item) => {
      if (!item.children?.length) return item;
      const children = stripHiddenFromList(item.children);
      return children.length ? { ...item, children } : { ...item, children: undefined };
    });
}

/** Filtros de menú lateral Vault (admin obsoleto, cloud oculto, etc.). */
export function filterVaultSidebarMenuItems(items: SidebarMenuItem[]): SidebarMenuItem[] {
  return filterVaultAdminDashboardMenuItems(stripHiddenFromList(items));
}
